import styled from 'styled-components';

const ArchiveSubHeader = styled.h2`
  color: #5b5b5b;
`;

export default ArchiveSubHeader;
